import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './people.json';

const People = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Social dynamics, relationships, and personality vocabulary. B2 level English exercises with grammar, vocab, and discussion."
            level="B2"
            title="People"
            image="/Images/techpeople1.webp"
            seoTitle="Free English Lesson Plans: People"
            seoDescription="Social dynamics, relationships, and personality vocabulary. B2 level English exercises with grammar, vocab, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default People;


